import { render, staticRenderFns } from "./getVoucherList.vue?vue&type=template&id=51a2bf52&lang=pug"
import script from "./getVoucherList.vue?vue&type=script&lang=js"
export * from "./getVoucherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports